import { Injectable } from '@angular/core';
import { Observable, ReplaySubject, of } from 'rxjs';
import { map, first, catchError } from 'rxjs/operators';
import { ACResourceService } from '@appcatalyst/ng-cms-core-lib';

@Injectable({
  providedIn: 'root'
})
export class InsurancesService {
  private insurances = new ReplaySubject<any>(1);
  private insurancesPicker = new ReplaySubject<any>(1);

  constructor(private cms: ACResourceService) { }

  public updateInsurances = (params: any) => {
    var path = `/contact/insurance-list`
    return this.cms.request('GET', path, params).pipe(
      first(),
      map(data => {
        this.insurances.next(data)
        return data
      })
    )
  }

  public getInsurances = (): Observable<any> => {
    return this.insurances.asObservable()
  }

  public updateInsurancesPicker = (params: any) => {
    var path = `/contact/insurance-list`
    return this.cms.request('GET', path, params).pipe(
      first(),
      map(data => {
        this.insurancesPicker.next(data.data)
        return data.data
      }),
      catchError(err => {
        this.insurancesPicker.next([])
        return of([])
      })
    )
  }

  public getinsurancesPicker = (): Observable<any> => {
    return this.insurancesPicker.asObservable()
  }

}
